import { Button, Flex, Grid, theme } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";

import { LocationFinderContext } from "./context";
import { Header } from "./Header";
import { LocationSearch } from "./LocationSearch";
import {
  LocationCardListContainer,
  LocationFlexContainer,
  LocationListingsContainer,
} from "./styled";

import { LocationCard } from "~/Atom/LocationCard/index";

export const LocationList: React.FC = () => {
  const { token } = theme.useToken();
  const breakpoints = Grid.useBreakpoint();
  const ctx = useContext(LocationFinderContext);
  const [take, setTake] = useState<number>(5);

  const ref = useRef<HTMLDivElement>();

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = 0;
    }
  }, [ctx.distanceCenter, ctx.activeFilterTypeValue]);

  return (
    <LocationListingsContainer
      $token={token}
      $breakpoints={breakpoints}
      gap="none"
    >
      <LocationFlexContainer>
        <Flex
          gap="middle"
          vertical={true}
          justify="flex-start"
          align="flex-start"
          style={{
            margin: "0.5rem",
          }}
        >
          <Header />
          <LocationSearch />
        </Flex>

        <LocationCardListContainer
          // @ts-expect-error styled-components is mutating ref types for some reason
          ref={ref}
          $token={token}
          $breakpoints={breakpoints}
        >
          <Flex
            gap="large"
            vertical={true}
            style={{
              marginBottom: !breakpoints.md ? "3rem" : undefined,
            }}
          >
            {ctx.filteredLocations?.slice(0, take).map((loc, idx) => (
              <LocationCard
                key={`${idx}-${loc.slug}`}
                active={loc.slug === ctx.activeMarkerSlug}
                hoverStyles={true}
                location={loc}
                distanceCenter={ctx.distanceCenter}
                onClick={() => {
                  ctx.setActiveMarkerSlug(loc.slug);
                  ctx.panMapTo({
                    lat: loc.geo.latitude,
                    lng: loc.geo.longitude,
                  });
                  ctx.setIsDrawerOpen(false);
                }}
                style={{
                  display: "block",
                }}
              />
            )) || <LocationCard key="loading" />}
            {take > 0 &&
              ctx.filteredLocations?.length &&
              ctx.filteredLocations.length > take && (
                <Button
                  type="primary"
                  ghost={true}
                  style={{
                    margin: "1rem 1.5rem 2rem 1.5rem",
                  }}
                  onClick={() => setTake((v) => v + 5)}
                >
                  {"Show more"}
                </Button>
              )}
          </Flex>
        </LocationCardListContainer>
      </LocationFlexContainer>
    </LocationListingsContainer>
  );
};
